import { Injectable } from '@angular/core';
import { ApiService } from '@ebb-v2/ebb-integration';
import { ICslb } from '@ebb-v2/ebb-integration';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class CslbLicenseService {

  constructor(private api: ApiService)  { }

  public getCslbLicense(licenseNumber: string): Observable<ICslb> {
    return this.api
      .get(
        `/LicensesValidation/GetContractorInformation?licenseNumber=${licenseNumber}`
      )
      .pipe(map(res => res as ICslb));
  }
}
